const sounds: Record<string, string> = {
  button: "assets/sounds/button-1.wav",
  button2: "assets/sounds/button-2.wav",
  button3: "assets/sounds/button-3.wav",
  click: "assets/sounds/click.wav",
  message: "assets/sounds/message.wav",
  signOut: "assets/sounds/signOut.wav",
  switch: "assets/sounds/switch.wav",
};

export default sounds;
